/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// This code is taking from vis-conditional-formatting Git Repo src/js/utils/ColorUtil.ts
export function getColorStyle(color, backgroundColor, pattern) {
	const style = {};
	const backgroundStyle = [];

	if (color) {
		style.color = color;
	}
	if (backgroundColor) {
		backgroundStyle.push(backgroundColor);
	}
	if (pattern) {
		backgroundStyle.push(`url('dashboard-core/images/patterns/${pattern}.svg')`);
		style.backgroundRepeat = 'repeat';
		const textShadows = [
			[2, 2, 2],
			[2, -2, 2],
			[2, 0, 2],
			[-2, 2, 2],
			[-2, -2, 2],
			[-2, 0, 2],
			[0, 2, 2],
			[0, -2, 2],
			[0, 0, 2]
		];
		style['text-shadow'] = textShadows.map(shadow => {
			return shadow.join('px ') + `px #ffffff`;
		}).join(',');
	}
	if (backgroundStyle.length > 0) {
		if (pattern) {
			style.background = backgroundStyle.join(' ');
		} else {
			style.backgroundColor = backgroundStyle[0];
		}
	}

	return style;
}



// WEBPACK FOOTER //
// ./src/js/utilities/ColorUtil.js